import { getAllAttachmentsSize } from '../../../attachments/public/operators';
export const attachmentSizeExceeded = ({
  attachments,
  maxTotalFileSizeLimit
}) => {
  if (!attachments || !maxTotalFileSizeLimit) {
    return null;
  }
  const totalSize = getAllAttachmentsSize(attachments);
  if (totalSize > maxTotalFileSizeLimit) {
    return {
      disabled: true,
      sendDisabledReason: 'TOTAL_ATTACHMENT_SIZE_LIMIT',
      options: {
        maxTotalFileSizeLimit
      }
    };
  }
  return null;
};